import { Grid, Flex, Box } from '@primer/components';
import * as React from 'react';
export default {
  Grid,
  Flex,
  Box,
  React
};